import React from 'react';

import { usePrefs } from 'wsm-common-data';
import { isInTransit } from 'wsm-highlighted-attribute';

import { getAttributeLabel } from '../../../utilities/getAttributeLabel';
import { formatCityStateDistance } from '../../../utilities/formatCityStateDistance';

import Delivery from './Delivery';
import LocationDistance from './LocationDistance';
import vehiclePropType from '../../../propTypes/vehiclePropType';

const LocationContainer = ({ vehicle }) => {
	const { deliveryEnabled } = usePrefs();
	const { trackingAttributes = [], status, attributes = [] } = vehicle;

	const geodistAttr = trackingAttributes.find(
		(attr) => attr.name === 'geodist'
	)?.value;
	const distance = geodistAttr ? parseInt(geodistAttr, 10) : null;
	const showDelivery =
		deliveryEnabled === 'true' && !isInTransit(status) && distance !== null;

	// Try cityStateDistance first (higher priority)
	const cityStateDistanceLabel = formatCityStateDistance(
		getAttributeLabel(attributes, 'cityStateDistance')
	);

	// Fallback to locationDistance if cityStateDistance is not available
	const locationDistanceLabel = !cityStateDistanceLabel
		? getAttributeLabel(attributes, 'locationDistance')
		: null;

	// Use cityStateDistance or fallback to locationDistance
	const finalLocationLabel = cityStateDistanceLabel || locationDistanceLabel;

	if (!showDelivery && !finalLocationLabel) return null;

	return (
		<div className="mb-3">
			{showDelivery && <Delivery distance={distance} />}
			{finalLocationLabel && (
				<LocationDistance
					label={finalLocationLabel}
					accountId={vehicle.accountId}
				/>
			)}
		</div>
	);
};

LocationContainer.propTypes = {
	vehicle: vehiclePropType.isRequired
};

export default LocationContainer;
